const TextAreaField = ({
  name,
  register,
  label,
  errors,
  valueAsNumber,
  red,
}) => {
  return (
    <div className="input-container">
      <label className="block text-text-1/90 font-medium" htmlFor={name}>
        {label}
      </label>
      <textarea
        className={`w-full p-4 h-40 border-2 text-base rounded-none bg-content border-bkg2 focus:outline-none ${
          red ? "focus:border-red-200" : "focus:border-primary"
        } text-text-1/75`}
        {...register(name, { valueAsNumber })}
      />
      {
        <p className="text-red-400 text-xs text-wrap w-fit">
          {errors && errors.message} <span className="invisible">Sample</span>
        </p>
      }
    </div>
  );
};

export default TextAreaField;
